import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$location', '$window',
  function EmailShare ($location, $window) {
    return {
      restrict: 'C',
      replace: true,
      templateUrl: cdnTemplate('/social-share-button.html'),
      scope: true,
      link: (scope) => {
        scope.share = function EmailShareCall () {
          $window.location.href = `mailto:?subject=Check%20out%20this%20shirt%20on%20Viralstyle.com&body=${encodeURIComponent($location.absUrl())}`;
        };
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/social-share/email.dir.js